<button
  mat-icon-button
  [attr.aria-label]="(direction === 'next' ? 'TRANS__SEARCH_RESULT_PAGER__NEXT' : 'TRANS__SEARCH_RESULT_PAGER__PREVIOUS') | translate"
  [disabled]="disable"
  (click)="setCurrentMedia()"
>
  <mat-icon>
    {{direction === 'next' ? 'chevron_right' : 'chevron_left'}}
  </mat-icon>
</button>
